// Atlas /my-portfolio design tokens
// Per ADR-0040 and atlas-portfolio-handoff-v2.md.
// - #00ff88 is Atlas neon — used as the gain color in value contexts here.
// - Loss is rose #fb7185 (calendar HIGH-impact pill palette), not red.
// - Sector palette keyed on canonical sector names from the live API.

export const YT = {
  page:        '#07090f',
  card:        '#0a0e1a',
  cardSoft:    'rgba(255,255,255,0.025)',
  cardHover:   'rgba(255,255,255,0.04)',
  borderSoft:  'rgba(255,255,255,0.04)',
  border:      'rgba(255,255,255,0.07)',
  borderStrong:'rgba(255,255,255,0.10)',

  ink:         '#f1f5f9',
  inkMid:      '#cbd5e1',
  inkMid2:     '#94a3b8',
  inkDim:      '#64748b',
  inkGhost:    '#475569',
  inkFaint:    '#3a4a64',

  accent:      '#00ff88',
  accentSoft:  'rgba(0,255,136,0.10)',
  accentTint:  'rgba(0,255,136,0.14)',
  accentDim:   'rgba(0,255,136,0.22)',
  accentEdge:  'rgba(0,255,136,0.4)',
  accentInk:   '#001a08',

  loss:        '#fb7185',
  lossSoft:    'rgba(251,113,133,0.10)',
  lossTint:    'rgba(251,113,133,0.14)',
  lossDim:     'rgba(251,113,133,0.22)',

  amber:       '#fbbf24',
  amberTint:   'rgba(251,191,36,0.14)',
  amberDim:    'rgba(251,191,36,0.22)',

  fontDisplay: "'Space Grotesk', system-ui, sans-serif",
  fontMono:    "'JetBrains Mono', 'Fira Code', monospace",
}

const YT_SECTORS = {
  'Cloud & Data Centers':                { hex: '#5EEAD4', label: 'CLOUD' },
  'Compute':                             { hex: '#3DFF8E', label: 'COMPUTE' },
  'Cybersecurity':                       { hex: '#A78BFA', label: 'CYBER' },
  'Defense':                             { hex: '#F87171', label: 'DEFENSE' },
  'Energy & Grid':                       { hex: '#FCD34D', label: 'ENERGY' },
  'Healthcare':                          { hex: '#4ADE80', label: 'HEALTHCARE' },
  'Memory & Storage':                    { hex: '#F0ABFC', label: 'MEMORY' },
  'Networking & Connectivity':           { hex: '#38BDF8', label: 'NETWORKING' },
  'Photonics':                           { hex: '#60A5FA', label: 'PHOTONICS' },
  'Power & Cooling':                     { hex: '#FB923C', label: 'POWER' },
  'Quantum Computing':                   { hex: '#C084FC', label: 'QUANTUM' },
  'Semiconductor Equipment & Materials': { hex: '#FBBF24', label: 'SEMI EQUIP' },
  _default:                              { hex: '#64748b', label: 'SECTOR' },
}

// In-universe ticker → sector mapping. The lookup is best-effort; if a ticker
// isn't covered, ytTickerSector falls through to the gray default. The page
// joins live data for in-universe tickers via Atlas's existing quote pipeline.
const TICKER_SECTOR = {
  NVDA: 'Compute',     AVGO: 'Compute',     TSM: 'Compute',     AMD: 'Compute',
  CRWV: 'Cloud & Data Centers',  ORCL: 'Cloud & Data Centers',
  VRT: 'Power & Cooling',  ETN: 'Power & Cooling',
  ASML: 'Semiconductor Equipment & Materials',
  AMAT: 'Semiconductor Equipment & Materials',
  KLAC: 'Semiconductor Equipment & Materials',
  LRCX: 'Semiconductor Equipment & Materials',
  MU: 'Memory & Storage',
  ANET: 'Networking & Connectivity',
  PANW: 'Cybersecurity', CRWD: 'Cybersecurity',
  LMT: 'Defense', RTX: 'Defense', NOC: 'Defense',
  IONQ: 'Quantum Computing', RGTI: 'Quantum Computing', QBTS: 'Quantum Computing',
  CRDO: 'Photonics', COHR: 'Photonics', LITE: 'Photonics',
  LLY: 'Healthcare',
}

export function ytSector(name) {
  return YT_SECTORS[name] || YT_SECTORS._default
}

export function ytTickerSector(t) {
  return ytSector(TICKER_SECTOR[t] || '_default')
}

export const IN_UNIVERSE = new Set(Object.keys(TICKER_SECTOR))
